export const imageBaseApi = "https://api-onshore-kangaroo.danfesolution.com";
